import { AxiosResponse } from 'axios';

import { SPBlockedReport } from './types';

export class SPBlockedError extends Error {
    public readonly sp: SPBlockedReport;

    public readonly originalResponse: AxiosResponse;

    constructor(sp: SPBlockedReport, originalResponse: AxiosResponse) {
        super('Request blocked by ServicePipe');
        this.name = 'SPBlockedError';
        this.sp = sp;
        this.originalResponse = originalResponse;
    }
}
